import { Component, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/core-api/services/auth/auth.service';
import { AbstractWorkflowResultComponent } from '../../../@core/abstract-workflow-result.component';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { ExpressionBuilderService } from '../../../expression-builder/expression-builder.service';
import { AgendaPlannerModel } from '../agenda-planner.model';
import * as moment from 'moment';

@Component({
  selector: 'abw-agenda-planner-result',
  templateUrl: './agenda-planner-result.component.html',
  styleUrls: ['./agenda-planner-result.component.scss']
})
export class AgendaPlannerResultComponent extends AbstractWorkflowResultComponent<AgendaPlannerModel> implements OnChanges {
  startDate: string = '';
  endDate: string = '';
  users: any[] = []; // Liste des utilisateurs
  daysList: { year: string, month: string, day: string, dayName: string, fullDate: string }[] = [];
  mergedYears: any[] = [];
  mergedMonths: any[] = [];
  userEntries: { [user: string]: { [date: string]: string } } = {}; // Stocke les saisies

  constructor(
    protected workflowComponentsService: WorkflowComponentsService,
    protected expressionBuilderService: ExpressionBuilderService,
    protected authService: AuthService,
    protected cdf: ChangeDetectorRef,
  ) {
    super(workflowComponentsService, expressionBuilderService, authService, cdf);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.value && !!changes.value.currentValue) {
      const keys = Object.keys(this.value);
      if (keys.length > 0) {
        const intervalDates = Object.keys(this.value[keys[0]]);
        this.startDate = moment.min(intervalDates.map(date => moment(date))).format("YYYY-MM-DD");
        this.endDate = moment.max(intervalDates.map(date => moment(date))).format("YYYY-MM-DD");
        
        this.users = this.model.datas.map(d => ({ ID: d[this.model.valueField], FULLNAME: d[this.model.displayField] }));
        this.generateDays();
      }
    }
  }

  generateDays() {
    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
    if (start > end) {
      return;
    }

    this.daysList = [];
    this.mergedYears = [];
    this.mergedMonths = [];
    this.userEntries = {};

    let currentDate = new Date(start);
    while (currentDate <= end) {
      this.daysList.push({
        year: currentDate.getFullYear().toString(),
        month: currentDate.toLocaleDateString('fr-FR', { month: 'short' }).replace('.', ''),
        day: currentDate.getDate().toString().padStart(2, '0'),
        dayName: this.getDayName(currentDate),
        fullDate: currentDate.toISOString().split('T')[0]
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Fusion des années et mois
    this.mergedYears = this.mergeColumns(this.daysList.map(d => d.year));
    this.mergedMonths = this.mergeColumns(this.daysList.map(d => d.month));

    // Initialisation des saisies
    const datasourceAgenda = !!this.model.additional.UIC_PARAMS.DATASOURCE_AGENDA?.DATASOURCE_DATAS ? this.model.additional.UIC_PARAMS.DATASOURCE_AGENDA.DATASOURCE_DATAS : {};
    //const codeClient = this._workflowComponentsService.context.formValues[this.model.additional.FORM_ID][this.model.additional.CODE_CLIENT];
    this.users.forEach(user => {
      this.userEntries[user.ID] = {};
      this.daysList.forEach(day => {
        this.userEntries[user.ID][day.fullDate] = !!this.value[user.ID] && !!this.value[user.ID][day.fullDate] ? this.value[user.ID][day.fullDate] : ''; // Valeur par défaut
      });
    });
  }

  mergeColumns(list: string[]): { value: string, colspan: number }[] {
      const merged: { value: string, colspan: number }[] = [];
      let lastValue = '';
      let count = 0;

      list.forEach((value, index) => {
          if (value === lastValue) {
              count++;
          } else {
              if (lastValue) merged.push({ value: lastValue, colspan: count });
              lastValue = value;
              count = 1;
          }
          if (index === list.length - 1) merged.push({ value, colspan: count });
      });

      return merged;
  }

  getDayName(dayOfMonth: Date) {
      // Tableau des noms des jours de la semaine
      const daysOfWeek = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];

      // Retourne le nom du jour de la semaine
      return daysOfWeek[dayOfMonth.getDay()];
  }
}